/* eslint-disable */
import {useEffect, useState, useCallback} from 'react'
import {initializeColumns} from './utils'
import {SideMenuContext} from './context'
import SidebarMenu from './components/SidebarMenu'
import {TableSettingsMenuProps} from './TableSettingsMenuTypes'

const TableSettingsMenu = ({
  defaultColumns,
  type,
  id,
  isDrawerOpen,
  closeDrawer,
  setIsDrawerOpen,
  dragDisable = false,
  permissionPath,
  refetch,
  globalDefaultColumnsList,
  isLoadingGlobalDefaultColumnsList,
  refetchGlobalDefaultColumnsList,
  updateGlobalDefaultColumnsTableSorting,
  isLoadingGlobalDefaultColumnOperation,
}: TableSettingsMenuProps) => {
  const [selectedColumns, setSelectedColumns] = useState<any>([])
  const [updatedDefaultColumn, setUpdatedDefaultColumn] = useState<any>([])
  const [initialSelectedColumns, setInitialSelectedColumns] = useState<any>([])

  const initializeColumnsCallback = useCallback(() => {
    initializeColumns(
      globalDefaultColumnsList,
      defaultColumns,
      setUpdatedDefaultColumn,
      setSelectedColumns,
      selectedColumns,
      setInitialSelectedColumns
    )
  }, [globalDefaultColumnsList, defaultColumns])

  useEffect(() => {
    initializeColumnsCallback()
  }, [initializeColumnsCallback, isDrawerOpen])

  const contextValue = {
    updatedDefaultColumn,
    type,
    id,
    isDrawerOpen,
    closeDrawer,
    setIsDrawerOpen,
    permissionPath,
    defaultColumns,
    initialSelectedColumns,
    globalDefaultColumnsList,
    selectedColumns,
    isLoadingGlobalDefaultColumnsList,
    isLoadingGlobalDefaultColumnOperation,
    refetch,
    setUpdatedDefaultColumn,
    setSelectedColumns,
    refetchGlobalDefaultColumnsList,
    updateGlobalDefaultColumnsTableSorting,
    dragDisable,
  }

  return (
    <SideMenuContext.Provider value={contextValue}>
      <SidebarMenu />
    </SideMenuContext.Provider>
  )
}

export default TableSettingsMenu
